module.exports = __webpack_public_path__ + "media/images/slide02-ori-3ffb49390c5228ea7853ead7c258b209.jpg";